export const SIZE_COLOR_MAPS = [
  "#3B82F6", // blue
  "#F97316", // orange
  "#22C55E", // green
  "#6366F1", // indigo
  "#06B6D4", // cyan
  "#84CC16", // lime
  "#EAB308", // yellow
  "#F59E0B", // amber
  "#14B8A6", // teal
  "#EC4899", // pink
  "#A855F7", // purple
  "#0F766E", // dark teal
  "#EF4444", // red
  "#FACC15", // light yellow
  "#38BDF8" // sky
]

export const reportBundle = {
  header: {
    caption: {
      ko: "세대별 사용량 비교",
      en: "Household Usage Comparison",
      es: "Comparacion del uso por hogar"
    }
  },
  load: {
    loading: {
      ko: "데이터를 불러오는 중입니다.",
      en: "Loading data...",
      es: "Cargando datos..."
    },
    failed: {
      ko: "데이터를 불러오지 못했습니다.",
      en: "Failed to load data.",
      es: "No se pudieron cargar los datos."
    },
    error: {
      ko: "에러가 발생했습니다.",
      en: "An error occurred.",
      es: "Ocurrio un error."
    }
  },
  totalUsageByHousehold: {
    ko: "세대별 총 {resource} 사용량 비교",
    en: "Comparison of Total {resource} Usage by Household",
    es: "Comparacion del uso total de {resource} por hogar"
  },
  usage: {
    ko: "{resource} 사용량",
    en: "{resource} Usage",
    es: "Uso de {resource}"
  },
  distribution: {
    ko: "{resource} 사용량 분포",
    en: "{resource} Usage Distribution",
    es: "Distribucion del uso de {resource}"
  },
  dong: { ko: "{dong} 동", en: "Building {dong}", es: "Edificio {dong}" },
  ho: { ko: "{ho}호", en: "Unit {ho}", es: "Unidad {ho}" },
  byDong: {
    ko: "동별 {resource} 사용량 비교",
    en: "Comparison of {resource} Usage by Building",
    es: "Comparacion del uso de {resource} por edificio"
  },
  byDongHousehold: {
    ko: "{dong}동 {resource} 사용량",
    en: "{resource} Usage by Household in Building {dong}",
    es: "Uso de {resource} por hogar en el edificio {dong}",
    mobile: {
      ko: "세대별 {resource} 사용량",
      en: "{resource} Usage by Household",
      es: "Uso de {resource} por hogar"
    }
  }
}
